import React from "react";
import GroupWrapper from "./Groups.js";
import GroupListPublic from "./GroupPubliclist";

export default function AllPublicGroupsPage() {
  return (

      <GroupListPublic />
 
  );
}
